module.exports = __webpack_public_path__ + "img/17867_L.bbcc632c.png";